
export class DwPubSubEventTopics {
    static clientConnected = 'pubSub/client/connected';
    static clientDisconnected = 'pubsub/client/disconnected'
    static clientError = 'pubsub/client/error';
    static videoLibraryPlaybackConfigurationChanged = 'VideoLibraryPlaybackConfigurationChanged';

    static messageReceived(topic:string) {
        return `dw/pubsub/message/received/${topic}`;
    } 
}
